import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../config/rbac/actions.ts";

import {AddPage as AddOrganizationAccountPage} from '../organization-accounts/pages/AddPage';

export const OrganizationsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListOrganizations') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateOrganization') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/organizations'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetOrganization') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/organizations'/>
                    )
                }

            >
            </Route>

            <Route
                path=':id/organization-accounts/add'
                element={
                    allowedActions.includes(rbacActions.CreateOrganizationAccount) ? (
                        <AddOrganizationAccountPage/>
                    ) : (
                        <Navigate to='/organization-accounts'/>
                    )
                }
            />


        </Routes>
    );
};
